<script lang="ts">
export default { name: 'OtpVerifyPhone' };
</script>

<script setup lang="ts">
import { useRouter } from 'vue-router';

//COMPONENTS
import { GForm, GFormItem } from '@flash-global66/g-form';
import { GInput } from '@flash-global66/g-input';
import { GSelect } from '@flash-global66/g-select';
import { GButton } from '@flash-global66/g-button';
import { GInline } from '@flash-global66/g-inline';
import GSelectAvatar from '@/components/GSelectNext/components/GSelectAvatar.vue';

// CONSTANTS
import { OTP_INLINE } from '@/shared/otp/constants/otpInline.constant';

// COMPOSABLES
import { useOtpVerifyPhone } from './useOtpVerifyPhone';

const router = useRouter();
const {
  rules,
  formContact,
  countrySelectOptions,
  formUserRef,
  onFilterCountry,
  onSendOtp,
  logOut,
} = useOtpVerifyPhone({
  onNavigateToMovements: () => router.push({ name: 'movements' }),
});
</script>
<template>
  <div class="flex h-fit flex-col items-center justify-between mt-8 mb-8" data-test="otp:verify-phone">
    <section class="px-6 sm:px-0 w-full max-w-2xl">
      <div class="flex justify-center mb-8">
        <img src="@/assets/img/security-world-icon.svg" alt="Icono de OTP" />
      </div>
      <div class="px-12 text-center mb-8">
        <h2 class="text-blue-14 text-8 font-semibold mb-6">
          Por regulación y por tu seguridad, necesitamos validar tu información
        </h2>
        <p class="text-blue-12 font-medium">
          Te sugerimos mantener tu móvil cerca para validar tu número de
          teléfono en el siguiente paso.
        </p>
      </div>
      <div>
        <h4 class="text-blue-14 font-bold mb-4">Teléfono de contacto</h4>
        <GForm ref="formUserRef" :model="formContact" :rules="rules" data-test="form:phone-validation">
          <div class="grid grid-cols-2 gap-2">
            <g-form-item prop="dialCodeSelected">
              <g-select
                v-model="formContact.dialCodeSelected"
                label="Código de país"
                value-key="id"
                filterable
                :filter-method="onFilterCountry"
                :options="countrySelectOptions"
                data-test="select:country-code"
              >
                <template #prefix>
                  <div class="flex justify-center items-center mx-1">
                    <g-select-avatar
                      :country-code="formContact.dialCodeSelected?.alpha2Code"
                    />
                  </div>
                </template>
                <template #default="{ item }">
                  <div class="flex items-center">
                    <g-select-avatar class="mr-3" :country-code="item.icon" />
                    <p>{{ item.title }}</p>
                  </div>
                </template>
                <template #selectedLabel="{ value }">
                  {{ `(+${value.dialCode}) ${value.nameES}` }}
                </template>
              </g-select>
            </g-form-item>

            <g-form-item prop="phoneNumber">
              <g-input
                v-model.trim="formContact.phoneNumber"
                type="tel"
                label="Número de teléfono"
                data-test="input:phone-number"
              />
            </g-form-item>
          </div>
        </GForm>
        <GInline
          class="mt-1"
          type="warning"
          :description="OTP_INLINE.VERIFY_PHONE_AUTH_DESCRIPTION"
          icon="solid triangle-exclamation"
          hide-close
        />
      </div>
    </section>
    <section class="flex flex-row w-1/2 max-w-s gap-8 mt-4 mb-4">
      <g-button variant="tertiary" @click="() => logOut()" full data-test="button:log-out">
        Cerrar sesión
      </g-button>
      <g-button @click="onSendOtp" full data-test="button:validate"> Ir a validar </g-button>
    </section>
  </div>
</template>
